let sticky_footer = (function( $ ) {

	let $footer,
		$content,
		old_footer_height = null;

	let _init = function() {
		$footer  = $( '#footer' );
		$content = $( '#content' );

		if ( $footer.length > 0 && $content.length > 0 ) {
			offset_footer();

			$( window ).smartresize( function() {
				offset_footer();
			} );
		}
	};

	let offset_footer = function() {
		let footer_height = $footer.outerHeight();

		if ( old_footer_height ) {
			let padding = ( parseInt( $content.css( 'padding-bottom' ) ) - old_footer_height ) + footer_height; // Remove previous footer height and add new height to ensure correct padding is added
			$content.css( 'padding-bottom', padding );
		} else {
			let padding = parseInt( $content.css( 'padding-bottom' ) ) + footer_height;
			$content.css( 'padding-bottom', padding );
		}

		old_footer_height = footer_height;

		$footer.attr( 'hidden', false );
	};

	$( document ).ready( _init );

	return {
		offset_footer: offset_footer
	};

})( jQuery );

module.exports = sticky_footer;